import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { SearchAppsParams, SearchAppsReturn } from "api/ApiGatewayApi";

import { Credentials } from "auth";
import { State } from "redux/state";

export { SearchAppsParams, SearchAppsReturn };

export type SearchApps = "SEARCH_APPS";
export const SEARCH_APPS: SearchApps = "SEARCH_APPS";
export type SearchAppsEnd = "SEARCH_APPS_END";
export const SEARCH_APPS_END: SearchAppsEnd = "SEARCH_APPS_END";

export interface SearchAppsAction extends Action {
    type: SearchApps;
    payload: {
        params: SearchAppsParams;
        credentials: Credentials;
    };
}

export function searchApps(params: SearchAppsParams): ThunkAction<void, State, undefined, SearchAppsAction> {
    return (dispatch: Dispatch<SearchAppsAction>, getState) => {
        const credentials = getState().auth.credentials;
        dispatch(searchAppsWithCredentials(params, credentials));
    };
}

function searchAppsWithCredentials(params: SearchAppsParams, credentials: Credentials): SearchAppsAction {
    return {
        payload: {
            credentials,
            params
        },
        type: SEARCH_APPS
    };
}

export interface SearchAppsEndAction extends Action {
    type: SearchAppsEnd;
    payload: {
        result?: SearchAppsReturn;
        error?: Error;
    };
}

export function searchAppsEnd(error: Error, result?: SearchAppsReturn): SearchAppsEndAction {
    return {
        payload: {
            error,
            result
        },
        type: SEARCH_APPS_END
    };
}
